import * as React from 'react'

export class ArrowBackIcon extends React.Component<
  { w: number; h: number } & React.SVGAttributes<SVGElement>,
  {}
> {
  public render() {
    const { w, h, ...props } = this.props
    const viewBox = `0 0 24 24`
    return (
      <svg
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        width={w}
        height={h}
        viewBox={viewBox}
        {...props}
      >
        <path d="M20.016 11.016v1.969h-12.188l5.578 5.625-1.406 1.406-8.016-8.016 8.016-8.016 1.406 1.406-5.578 5.625h12.188z" />
      </svg>
    )
  }
}
